import { Platform, Linking, Alert } from 'react-native';

/**
 * Handles the "Buy Piccolo a treat" interaction based on the current platform.
 * Web: Redirects to PayPal.
 * Native: Placeholder for In-App Purchase flow (RevenueCat/Stripe).
 */
export const handleBuyTreat = () => {
  if (Platform.OS === 'web') {
    Linking.openURL('https://paypal.me/piclotreat');
  } else {
    // Native In-App Purchase Flow (Placeholder)
    console.log('Triggering Native IAP Flow (RevenueCat/Stripe)...');
    
    // Using Alert for native platforms to provide immediate feedback
    Alert.alert(
      "Buy Piccolo a treat 🦴",
      "Native in-app purchases are coming soon! Thank you for your support.",
      [{ text: "OK" }]
    );
  }
};
